import { render, staticRenderFns } from "./AccountSettingRateTable.vue?vue&type=template&id=6198f45a&scoped=true&"
import script from "./AccountSettingRateTable.vue?vue&type=script&lang=js&"
export * from "./AccountSettingRateTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingRateTable.vue?vue&type=style&index=0&id=6198f45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6198f45a",
  null
  
)

export default component.exports